import React from 'react';
import { motion } from 'framer-motion';
import { FiCheck, FiArrowLeft, FiAlertCircle } from 'react-icons/fi';
import logger from '../../../utils/logging/logger';
import styles from '../PaymentForm.module.css';

// The three early-return screens for PaymentFormContent, extracted VERBATIM:
// while course/product data loads, when nothing was found, and after a
// successful payment (just before the redirect).

export function PaymentLoadingScreen() {
  return (
    <div className={styles.container}>
      <motion.div
        className={styles.paymentCard}
        initial={false}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <div className={styles.loadingSpinner} />
          <p style={{ marginTop: '1rem', color: 'var(--fi-muted)' }}>
            Loading course information...
          </p>
        </div>
      </motion.div>
    </div>
  );
}

export function PaymentNotFoundScreen({ courses, error, productIds, courseId, courseIds, loading, navigate }) {
  // FIX: Safely get error message to prevent render errors
  let errorMessage = '';
  try {
    errorMessage = error || (productIds
      ? 'Product(s) not found or not available for purchase. Please check the product codes and try again.'
      : 'Course(s) not found or not available for enrollment. Please check the course codes and try again.');
  } catch (e) {
    logger.error('Error getting error message', { e });
    errorMessage = 'An error occurred while loading course information. Please try again.';
  }

  logger.warn('No courses found', { courseId, courseIds, productIds, loading, error: errorMessage });
  return (
    <div className={styles.container}>
      <motion.div
        className={styles.paymentCard}
        initial={false}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className={styles.backButtonContainer}>
          <button className={styles.backButton} onClick={() => navigate('/catalog')} aria-label="Back to course catalog">
            <FiArrowLeft size={16} />
            Back to Course Catalog
          </button>
        </div>
        <motion.div
          className={styles.errorMessage}
          role="alert"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className={styles.errorIcon}>
            <FiAlertCircle />
          </div>
          <div className={styles.errorText}>
            {errorMessage}
          </div>
        </motion.div>
        {!error && (
          <div style={{ textAlign: 'center', marginTop: '1rem' }}>
            <p style={{ color: 'var(--text-secondary)', marginBottom: '1rem' }}>
              If you believe this is an error, please contact support.
            </p>
          </div>
        )}
      </motion.div>
    </div>
  );
}

export function PaymentSuccessScreen({ productIds, courses }) {
  return (
    <div className={styles.container}>
      <motion.div
        className={styles.paymentCard}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className={styles.successMessage}>
          <FiCheck size={20} />
          Payment successful! You've been {productIds ? 'granted access to' : 'enrolled in'} {courses && courses.length > 0 ? courses.length : 0} {productIds ? 'product' : 'course'}{(courses && courses.length !== 1) ? 's' : ''}.
          Redirecting to {productIds ? 'confirmation page' : 'My Courses'}...
        </div>
      </motion.div>
    </div>
  );
}
